import { ChangeEvent } from "react"

import { Form } from "react-bootstrap"

import DonorIdsCell from "./DonorIdsCell"
import { OrphanedDonor } from "../../../api/OrderRequests/OrderRequestsModel/Donor"

interface OrphanedDonorParams {
  donor: OrphanedDonor
  selected?: boolean
  onSelectDonor: (donorId: number) => void
}

function DonorRow(params: OrphanedDonorParams) {
  const { donor, selected, onSelectDonor } = params
  const { PersonID, FirstName, LastName, Company, Location } = donor

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSelectDonor(Number(e.target.value))
  }

  return (
    <tr>
      <td>
        <Form.Check
          type="checkbox"
          name="orphaned-donor"
          id={`od_${PersonID}`}
          className="abc-checkbox abc-checkbox-primary d-flex justify-content-center align-middle"
          value={PersonID}
          label=""
          checked={selected}
          onChange={handleChange}
        />
      </td>
      <td>{FirstName}</td>
      <td>{LastName}</td>
      {DonorIdsCell(donor)}
      <td>{Company}</td>
      <td>{Location}</td>
    </tr>
  )
}

export default DonorRow
